import * as React from 'react';
import { SVGProps } from 'react';

const SubscriptionSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 20 20'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <g
      stroke='#A0A4A8'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      clipPath='url(#a)'
    >
      <path d='M14.166.833 17.5 4.167 14.166 7.5' />
      <path d='M2.5 9.166V7.5a3.333 3.333 0 0 1 3.333-3.333H17.5M5.833 19.167 2.5 15.833 5.833 12.5' />
      <path d='M17.5 10.834V12.5a3.333 3.333 0 0 1-3.333 3.334H2.5' />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h20v20H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SubscriptionSidebar;
